module.exports = __webpack_public_path__ + "img/pr-2.b85f6e42.png";